import volumetricPrinting from "./templates/volumetric-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <h3>Чехол для iPhone 11 Pro Max, объёмная печать</h3>
        <p>Чехол изготавливается из пластика с покрытием soft touch.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${volumetricPrinting}`
    }
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
